<template>
    <!-- placeholder in the shape of the default teaser while results load; purely visual -->
    <div :class="classes.teaserSkeleton.teaser">
        <div :class="classes.teaserSkeleton.image">
            <span :class="classes.teaserSkeleton.imagePlaceholder"></span>
        </div>
        <div :class="classes.teaserSkeleton.body">
            <span :class="[classes.teaserSkeleton.line, classes.teaserSkeleton.lineTitle]"></span>
            <span :class="classes.teaserSkeleton.line"></span>
            <span :class="[classes.teaserSkeleton.line, classes.teaserSkeleton.lineShort]"></span>
            <span :class="[classes.teaserSkeleton.line, classes.teaserSkeleton.lineUrl]"></span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useClasses } from './composables/useClasses'

const classes = useClasses()
</script>
